import React from "react";
import { Link } from "react-router-dom";
import { BRAND, getMapEmbedUrl } from "../../config/locations";

// Footer is location-aware. When a `location` is passed (Sidcup / Ebbsfleet
// pages) it shows that gym's email, phone, full address and a small Google map.
// On the brand hub ("/") no location is passed, so it falls back to brand-level
// contact details (email + phone) with no single address or map.
const Footer = ({ location }) => {
	const email = location?.contactEmail || BRAND.email;
	const phone = location?.phone || BRAND.phone;
	const phoneDisplay = location?.phoneDisplay || BRAND.phoneDisplay;

	const addr = location?.address;
	const hasAddress =
		addr?.streetAddress && !String(addr.streetAddress).startsWith("TODO");
	const addressLine = hasAddress
		? [
				addr.streetAddress,
				addr.addressLocality,
				addr.addressRegion,
				addr.postalCode,
			]
				.filter(Boolean)
				.join(", ")
		: null;

	const mapEmbedUrl = location ? getMapEmbedUrl(location) : null;

	return (
		<footer className="modern-footer">
			<div className="modern-footer-container">
				{/* Back to the location hub — only shown on a gym page (where a
				    location is set), giving mobile users an easy way back since the
				    navbar menu is hidden on small screens. */}
				{location && (
					<div className="modern-footer-back">
						<Link to="/" className="modern-footer-back-link">
							← All Locations
						</Link>
					</div>
				)}

				<div className="modern-footer-content">
					<div className="modern-footer-brand">
						<img
							src={process.env.PUBLIC_URL + "/EU59_LogoWHTAsset 5@4x.png"}
							alt="Urban 59"
							className="modern-footer-logo"
						/>
					</div>

					<div className="modern-footer-links">
						<div className="modern-footer-column">
							<h4>Contact</h4>
							<p>
								Email: <a href={`mailto:${email}`}>{email}</a>
							</p>
							<p>
								Phone: <a href={`tel:${phone}`}>{phoneDisplay}</a>
							</p>
							{addressLine && <p>{addressLine}</p>}
						</div>

						<div className="modern-footer-column">
							<h4>Follow Us</h4>
							<a
								href="https://g.page/r/CaptRLiGYbtCEBM/review"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Visit our Google Business Profile"
							>
								📍 Google Reviews
							</a>
							<a
								href="https://www.instagram.com/urban59training"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Follow us on Instagram"
							>
								📷 Instagram
							</a>
							<a
								href="https://www.facebook.com/sophievictoriapt"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Follow us on Facebook"
							>
								👍 Facebook
							</a>
						</div>

						{/* Small Google map for the current location (keyless embed). */}
						{mapEmbedUrl && (
							<div className="modern-footer-column modern-footer-map">
								<h4>Find Us</h4>
								<iframe
									title={`Map to ${location?.name || "Urban 59"}`}
									src={mapEmbedUrl}
									loading="lazy"
									referrerPolicy="no-referrer-when-downgrade"
									style={{
										width: "100%",
										maxWidth: "280px",
										height: "180px",
										border: 0,
										borderRadius: "8px",
									}}
								></iframe>
							</div>
						)}
					</div>
				</div>

				<div className="modern-footer-bottom">
					<p>
						&copy; {new Date().getFullYear()} Urban 59. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
